// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WorkshopSessions_wrapper__ReZIw"};